import MobilitySkill from './MobilitySkill.js';

export default class TrampolineMobilitySkill extends MobilitySkill {
    static entity = 'trampoline-mobility-skills';
}
